"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TablePreamble = function TablePreamble(_ref) {
  var dropdowns = _ref.dropdowns,
    dropdownOnChange = _ref.dropdownOnChange,
    rowsCount = _ref.rowsCount,
    rowsPerPageOptions = _ref.rowsPerPageOptions,
    rowsPerPage = _ref.rowsPerPage,
    rowsPerPageOnChange = _ref.rowsPerPageOnChange,
    searchAll = _ref.searchAll,
    searchAllOnChange = _ref.searchAllOnChange,
    className = _ref.className,
    searchAllVisibility = _ref.searchAllVisibility;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, dropdowns.map(function (dropdown, index) {
    var defaultValue = "";
    if (dropdown.value) {
      var valueIndex =
      // Fuzzy-match the value in the select, in case an initial value in props was passed
      dropdown.options.findIndex(function (option) {
        return option.toLowerCase().match(dropdown.value.replace(/"/g, "").replace(/\s+/g, " ").trim().toLowerCase());
      });
      if (valueIndex >= 0) {
        defaultValue = dropdown.options[valueIndex];
      }
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: "small-12 medium-4 large-2 columns"
    }, /*#__PURE__*/_react["default"].createElement("label", null, dropdown.label, ":", /*#__PURE__*/_react["default"].createElement("select", {
      defaultValue: "\"".concat(defaultValue, "\""),
      onChange: function onChange(e) {
        return dropdownOnChange(dropdown.dataKey, e.target.value, false);
      }
    }, /*#__PURE__*/_react["default"].createElement("option", {
      value: ""
    }, "All"), dropdown.options.map(function (option, index) {
      return /*#__PURE__*/_react["default"].createElement("option", {
        key: index,
        value: "\"".concat(option, "\"")
      }, option);
    }))));
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("label", null, "Entries per page:", /*#__PURE__*/_react["default"].createElement("select", {
    defaultValue: rowsPerPage,
    onChange: function onChange(e) {
      return rowsPerPageOnChange(Number.parseInt(e.target.value));
    }
  }, rowsPerPageOptions.filter(function (rowsPerPageOption) {
    return rowsCount >= rowsPerPageOption;
  }).map(function (rowsPerPageOption, index) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: index,
      value: rowsPerPageOption
    }, rowsPerPageOption);
  }), /*#__PURE__*/_react["default"].createElement("option", {
    value: 0
  }, "All")))), /*#__PURE__*/_react["default"].createElement("div", {
    className: className,
    style: {
      visibility: searchAllVisibility
    }
  }, /*#__PURE__*/_react["default"].createElement("label", null, "Search all columns:", /*#__PURE__*/_react["default"].createElement("input", {
    type: "search",
    value: searchAll,
    onChange: function onChange(e) {
      return searchAllOnChange(e.target.value);
    }
  }))));
};
TablePreamble.propTypes = {
  dropdowns: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    dataKey: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].string,
    options: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired
  })).isRequired,
  dropdownOnChange: _propTypes["default"].func.isRequired,
  rowsCount: _propTypes["default"].number.isRequired,
  rowsPerPageOptions: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  rowsPerPage: _propTypes["default"].number.isRequired,
  rowsPerPageOnChange: _propTypes["default"].func.isRequired,
  searchAll: _propTypes["default"].string.isRequired,
  searchAllOnChange: _propTypes["default"].func.isRequired,
  className: _propTypes["default"].string
};
TablePreamble.defaultProps = {
  className: "small-12 medium-4 large-2 columns"
};
var _default = exports["default"] = TablePreamble;